import { apiMutate } from '../../utils/mutation';
import sendCartLink from '../../mutations/manualOrdering/sendCartLink';
import ServiceConfigs from '../../config';
import { SendCartLinkPayload, MutationSendCartLinkArgs } from '../../types/generated';

type useSendCartLinkType = ({
  isCartAuthorized,
}: {
  isCartAuthorized: boolean;
}) => (variables: MutationSendCartLinkArgs) => Promise<SendCartLinkPayload | { hasError: boolean }>;

const useSendCartLink: useSendCartLinkType =
  ({ isCartAuthorized }) =>
  variables =>
    apiMutate({
      mutation: sendCartLink,
      variables: { ...variables, subdomain: ServiceConfigs.getSubDomain() },
      requestHeaders: isCartAuthorized ? { ...ServiceConfigs.getAuthorizationHeader() } : {},
    }).then(response => response !== undefined && response);

export default useSendCartLink;
